<template>
  <div>
    <div class="current-items">
      <h6 class="mb-0">
        <font-awesome-icon icon="exclamation-triangle" />
        {{ $t("ig.current-ig-title") }}
      </h6>
      <div class="m-2">
        <div class="table-responsive-sm">
          <table id="currentTable" class="table b-table table-hover table-bordered table-sm">
            <thead class="thead-dark text-center">
              <tr>
                <th
                  v-for="field in fields"
                  :key="field.key"
                  @click="sortCurrentTable(field.key)"
                >
                  {{ field.label }}
                  <font-awesome-icon icon="sort" v-if="field.sortable" />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="currentItems.length === 0" class="text-center">
                {{ $t('ig.no-ig') }}
              </tr>
              <tr v-for="item in currentItems" :key="item" class="text-center">
                <td v-for="field in fields" :key="field">
                  <span v-if="field.key === 'status'">
                    <span class="badge badge-error"
                      v-if="item[field.key] === 'validated'"
                    >
                    {{ $t(`ig.status.${item[field.key]}`) }}
                    </span>
                    <span class="badge badge-warning"
                      v-if="item[field.key] === 'detected'"
                    >
                      {{ $t(`ig.status.${item[field.key]}`) }}
                    </span>
                  </span>
                  <span v-else-if="field.key === 'departments'">
                    <span
                      v-for="dep in item[field.key]"
                      :key="dep"
                      class="display-nra-department m-1"
                    >
                      {{ dep }}
                    </span>
                  </span>
                  <span v-else-if="field.key === 'nra'">
                    <span
                      v-for="nra in item[field.key]"
                      :key="nra"
                      class="display-nra-department m-1"
                    >
                      <span class="badge badge-secondary">
                        {{ nra }}
                      </span>
                    </span>
                  </span>
                  <span v-else-if="field.key === 'technologies'">
                    <span
                      v-for="(techno, index) in item[field.key]"
                      :key="index"
                      class="display-nra-department m-1"
                    >
                      {{ techno.toUpperCase() }}
                    </span>
                  </span>
                  <span v-else-if="field.key === 'nature'">
                    {{ decodeString(item[field.key]) }}
                  </span>
                  <span v-else-if="field.key === 'endDate'">
                    <span v-if="item[field.key] != null">{{ item[field.key] }}</span>
                    <span v-else>-</span>
                  </span>
                  <span v-else-if="field.key === 'estimatedResolutionDate'">
                    <span v-if="item[field.key] != null">{{ item[field.key] }}</span>
                    <span v-else>-</span>
                  </span>
                  <span v-else-if="field.key === 'comment'">
                    <span class="comment-cell" v-if="item[field.key] === ''">-</span>
                    <span class="comment-cell" v-else>
                      {{ item[field.key] }}
                    </span>
                  </span>
                  <span v-else>
                    {{ item[field.key] }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="last-items">
      <div data-bs-toggle="collapse" role="button" data-bs-target="#collapse-1" aria-expanded="false" aria-controls="collapse-1" @click="visible = !visible">
        <h6 class="mb-0">
          <font-awesome-icon icon="check-circle" />
          {{ $t("ig.last-ig-title") }}
          <font-awesome-icon icon="angle-down" v-if="visible" />
          <font-awesome-icon icon="angle-right" v-if="!visible" />
        </h6>
      </div>
      <div id="collapse-1" class="collapse">
        <div class="m-2">
          <div class="last-items-table b-table-sticky-header table-responsive-sm">
            <table id="lastTable" class="table b-table table-hover table-bordered">
              <thead class="thead-dark text-center">
                <tr>
                  <th
                    v-for="field in fields"
                    :key="field.key"
                    @click="sortLastTable(field.key)"
                  >
                    {{ field.label }}
                    <font-awesome-icon icon="sort" v-if="field.sortable" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="lastItems.length === 0" class="text-center">
                  {{ $t('ig.no-last-ig') }}
                </tr>
                <tr v-for="item in lastItems" :key="item" class="text-center">
                  <td v-for="field in fields" :key="field">
                    <span v-if="field.key === 'status'">
                      <span class="badge badge-success"
                      >
                      {{ $t(`ig.status.${item[field.key]}`) }}
                      </span>
                    </span>
                    <span v-else-if="field.key === 'departments'">
                      <span
                        v-for="dep in item[field.key]"
                        :key="dep"
                        class="display-nra-department m-1"
                      >
                        {{ dep }}
                      </span>
                    </span>
                    <span v-else-if="field.key === 'nra'">
                      <span
                        v-for="nra in item[field.key]"
                        :key="nra"
                        class="display-nra-department m-1"
                      >
                        <span class="badge badge-secondary">
                          {{ nra }}
                        </span>
                      </span>
                    </span>
                    <span v-else-if="field.key === 'technologies'">
                      <span
                        v-for="(techno, index) in item[field.key]"
                        :key="index"
                        class="display-nra-department m-1"
                      >
                        {{ techno.toUpperCase() }}
                      </span>
                    </span>
                    <span v-else-if="field.key === 'nature'">
                      {{ decodeString(item[field.key]) }}
                    </span>
                    <span v-else-if="field.key === 'endDate'">
                      <span v-if="item[field.key] != null">{{ item[field.key] }}</span>
                      <span v-else>-</span>
                    </span>
                    <span v-else-if="field.key === 'estimatedResolutionDate'">
                      <span v-if="item[field.key] != null">{{ item[field.key] }}</span>
                      <span v-else>-</span>
                    </span>
                    <span v-else-if="field.key === 'comment'">
                      <span class="comment-cell" v-if="item[field.key] != ''">{{ item[field.key]}}</span>
                      <span class="comment-cell" v-else>-</span>
                    </span>
                    <span v-else>
                      {{ item[field.key] }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sortBy } from 'lodash';

export default {
  name: "IncidentsView",
  props: {
    incidentsList: Array,
  },
  data() {
    return {
      visible: false,
      currentItems: [],
      lastItems: [],
      fields: [
        { key: "status", label: this.$t("ig.table.status") },
        {
          key: "departments",
          label: this.$t("ig.table.departments"),
          sortable: true,
        },
        { key: "nra", label: this.$t("ig.table.nra"), sortable: true },
        {
          key: "technologies",
          label: this.$t("ig.table.technology"),
          sortable: true,
        },
        { key: "nature", label: this.$t("ig.table.igNature"), sortable: true },
        { key: "default", label: this.$t("ig.table.default"), sortable: true },
        {
          key: "creationDate",
          label: this.$t("ig.table.start-date"),
          sortable: true,
        },
        { key: "endDate", label: this.$t("ig.table.end-date"), sortable: true },
        {
          key: "estimatedResolutionDate",
          label: this.$t("ig.table.estimated-resolution-date"),
          sortable: true,
        },
        { key: "comment", label: this.$t("ig.table.comments") },
      ],
    };
  },
  created() {
    this.loadCurrentIncidentsList();
    this.loadLastIncidentsList();
  },
  methods: {
    // Load list of current incidents
    loadCurrentIncidentsList() {
      this.currentItems = this.incidentsList.filter(
        (incident) => ["validated", "detected"].indexOf(incident.status) !== -1
      );
    },

    // Load list of last 7 days closed incidents
    loadLastIncidentsList() {
      this.lastItems = this.incidentsList.filter(
        (incident) => incident.status === "closed"
      );
    },
    // Decode string with accents
    decodeString(value) {
      if (value) {
        return decodeURIComponent(escape(value));
      }
      return '';
    },
    sortCurrentTable(col) {
      const sortList = sortBy(this.currentItems, col);
      this.currentItems = sortList;
    },
    sortLastTable(col) {
      const sortList = sortBy(this.lastItems, col);
      this.lastItems = sortList;
    }
  },
  watch: {
    incidentsList() {
      this.loadCurrentIncidentsList();
      this.loadLastIncidentsList();
    },
  },
};
</script>

<style>
.current-items {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding: 1rem;
  text-align: left;
  margin: 1rem;
}
.last-items {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding: 1rem;
  text-align: left;
  margin: 1rem;
}
.display-nra-department {
  display: flex;
  flex-direction: column;
  text-align: center;
}
.badge-success {
  color: #fff;
  background-color: #28a745;
}
.badge-error {
  background-color: #ed7e73;
}
.badge-warning {
  color: #212529;
  background-color: #ffc107;
}
.badge-secondary {
  color: #fff;
  background-color: #6c757d;
}
.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: #454d55;
}
.table-bordered thead td,
.table-bordered thead th {
  border-bottom-width: 2px;
}
.comment-cell {
  /* width: 450px; */
  display: block;
  white-space: pre-wrap;
  word-wrap: break-word;
  text-align: justify;
  font-size: 0.8em;
  font-weight: normal;
  padding: 9.5px;
  margin: 0 0 10px;
  line-height: 1.428571429;
  /* word-break: break-all; */
  color: #333;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: var(--bs-font-monospace);
}
.last-items-table {
  height: 90vh;
  max-height: 90vh !important;
}
</style>
